import { Observable } from 'rxjs';
import { NgModule, Optional, SkipSelf, APP_INITIALIZER, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

// services
import { UserService } from './services/user.service';
import { DialogComponent } from './dialog/dialog.component';
import { HTTP_INTERCEPTORS, HttpHeaders, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';

export function userServiceFactory(service: UserService): any {
  return () => service.getProfile();
}

// @Injectable()
// export class CustomHttpInterceptor implements HttpInterceptor {
//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     const modified = req.clone({setHeaders: {'Authorization': 'Bearer '+localStorage.getItem('access_token')}});
//     return next.handle(modified);
//   }
// }

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    FlexLayoutModule,
    MatSnackBarModule
  ],
  declarations: [DialogComponent],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (userServiceFactory),
      deps: [UserService],
      multi: true
    },

  //   {  provide: HTTP_INTERCEPTORS,
  //     useClass: CustomHttpInterceptor,
  //     multi: true
  //  }
  
  ],
  entryComponents: [DialogComponent]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(`CoreModule has already been loaded. Import Core modules in the AppModule only.`);
    }
  }
}
